import "./CampaignUploadLeads.scss";
import React, { useCallback, useRef, useState, useEffect } from "react";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { useParams, useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { useLazyQuery } from "@apollo/client";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Drop from "../../../assets/images/Group6120.svg";
import useUnsavedChangeWarning from "../../../hooks/useUnsavedChangeWarning";
import leadsFileValidator from "../../../utils/helpers/leadsFileValidator";
import { UPLOAD_LEADS } from "../../../gql/campaign/leads/mutation";
import { GET_GLOBAL_OUTBOUNDS_FIELDS } from "../../../gql/campaign/leads/queries";

const CampaignUploadLeads = ({ handleFile }) => {
  const { id } = useParams();
  const history = useHistory();
  const [files, setFiles] = useState([]);
  //eslint-disable-next-line
  const [fields, setFields] = useState([]);
  const hiddenInputRef = useRef(null);

  const [errorMessage, setErrorMessage] = useState("");
  //eslint-disable-next-line
  const [validExt, setValidExt] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [uploadLeadSuccess, setUploadLeadSuccess] = useState(false);
  const [Prompt, setIsDirty, setPristine] = useUnsavedChangeWarning();
  const [leadPageRedirect, setLeadPageRedirect] = useState(false);

  const [uploadLead, { loading }] = useMutation(UPLOAD_LEADS, {
    onCompleted(data) {
      setUploadLeadSuccess(true);
    },
    onError(error) {
      if (error) {
        if (
          error.networkError &&
          typeof window !== "undefined" &&
          !window.navigator.onLine
        ) {
          setErrorMessage("Check Your Network, Your Browser Is Offline");
        }
        if (error.message) {
          setErrorMessage(error.message);
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !");
        }
      }
    },
  });

  const [getGlobalOutboundFields] = useLazyQuery(GET_GLOBAL_OUTBOUNDS_FIELDS, {
    onCompleted(data) {
      setFields(data?.getGlobalOutboundFieldList);
    },
    onError(error) {
      if (error) {
        if (
          error.networkError &&
          typeof window !== "undefined" &&
          !window.navigator.onLine
        ) {
          setErrorMessage("Check Your Network, Your Browser Is Offline");
        }
        if (error.message) {
          setErrorMessage(error.message);
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !");
        }
      }
    },
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    getGlobalOutboundFields();

    //eslint-disable-next-line
  }, []);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles) {
      const name = acceptedFiles[0].name;
      setSelectedFileName(name);
      setIsDirty();
      const { extValid, ext } = leadsFileValidator(name);
      if (!extValid) {
        setValidExt(false);
        return toast.error(`.${ext} extension is not allowed`, {
          position: "bottom-right",
          closeOnClick: true,
        });
      }
      setValidExt(true);
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    }
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (history?.location?.search === "?leadTrue") setLeadPageRedirect(true);
  }, [leadPageRedirect, history]);

  const fileSelectedHandler = (e) => {
    if (e.target.files[0]) {
      const name = e.target.files[0].name;
      setSelectedFileName(name);
      setIsDirty();
      const { extValid, ext } = leadsFileValidator(name);
      if (!extValid) {
        setValidExt(false);
        return toast.error(`.${ext} extension is not allowed`, {
          position: "bottom-right",
          closeOnClick: true,
        });
      }
      setValidExt(true);
      setFiles(e.target.files);
    }
  };

  //eslint-disable-next-line
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    noClick: true,
  });

  const handleSave = () => {
    setPristine();
    try {
      if (!id) {
        return toast.error("Choose Campaign First.", {
          position: "bottom-right",
          closeOnClick: true,
        });
      }

      if (!files) {
        return toast.error("Please Choose File First.", {
          position: "bottom-right",
          closeOnClick: true,
        });
      }

      if (files) {
        uploadLead({
          variables: {
            campaignId: id,
            file: files[0],
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (errorMessage) {
    toast.error(errorMessage, {
      position: "bottom-right",
      closeOnClick: true,
    });
    setErrorMessage("");
  }

  if (uploadLeadSuccess) {
    toast.success("Successfully Saved.", {
      position: "bottom-right",
    });
    setPristine();
    setSelectedFileName();
    setValidExt(false);
    setUploadLeadSuccess(false);
    if (leadPageRedirect) {
      history.push(`/campaignCsv/${id}?leadTrue`);
    }else{
    history.push(`/campaignCsv/${id}`);
    }
  }

  const handleBack = () => {
    if (leadPageRedirect) {
      history.push(`/campaigns/leads/${id}`);
    } else {
      history.push("/campaign-name");
    }
  };
  return (
    <>
      <div className="campaign-details">
        <div className="create-title">
          <h4>Upload Leads</h4>
        </div>
        {/* Upper Sidebar */}
        <Container fluid>
          <Row className="leads-container">
            <Col
              // md={6}
              className="leads-upload d-flex flex-column align-items-center justify-content-center file-upload-wrapper"
              {...getRootProps()}
              style={{ marginRight: "30px" }}
            >
              <div className="leads-upload-icon-container">
                <img src={Drop} alt="" />
              </div>
              <div className="leads-upload-heading-btn-container">
                <div>
                  <span className="leads-upload-btn-heading">
                    Drag Or upload your File
                  </span>
                </div>
                <div className="leads-upload-btn-container text-center">
                  <input
                    type="file"
                    className="d-none"
                    ref={hiddenInputRef}
                    onChange={fileSelectedHandler}
                    // {...getInputProps()}
                  />
                  <Button
                    className="leads-upload-btn"
                    variant="outline-primary"
                    onClick={() => {
                      hiddenInputRef.current.click();
                    }}
                  >
                    Browse Files
                  </Button>
                  <div style={{ marginTop: "18px" }}>
                    {selectedFileName && <span>{selectedFileName}</span>}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <div style={{ marginLeft: "30px", marginTop: "20px" }}>
            <span
              style={{
                color: "#0A1E43",
                fontFamily: "DM Sans",
                fontWeight: "500",
              }}
            >
              Note: Please make sure Email field is included in your file.
            </span>
          </div>
          <Container fluid style={{ width: "100%" }}>
            <Row
              className="leads-back-next-container justify-content-end"
              xs="auto"
              md="auto"
              lg="auto"
              // style={{ marginTop: '4%' }}
            >
              <Col md={{ span: 1 }} className="margin-1600">
                {loading ? (
                  <Button className="upload_btn_back" disabled>
                    {" "}
                    Back
                  </Button>
                ) : (
                  <Button className="upload_btn_back" onClick={handleBack}>
                    {" "}
                    Back
                  </Button>
                )}
                {loading ? (
                  <Button className="solid-button upload_btn_save">
                    Save & Next &nbsp;
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </Button>
                ) : (
                  <Button
                    className="solid-button upload_btn_save"
                    onClick={handleSave}
                  >
                    Save & Next
                  </Button>
                )}
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
      {Prompt}
    </>
  );
};

export default CampaignUploadLeads;
